// extracted by mini-css-extract-plugin
module.exports = {"root":"z6gNR8xB","heading":"nMpCUOOM","content":"__3e_Fq8sH","item":"SHvgK8th","buttons":"ham3ATaY"};